import React, { useId, useState } from "react";
import { Icon } from "@iconify/react";
import s from "./Auth.module.css";

export function AuthField({ label, icon, error, hint, trailing, ...inputProps }) {
  const id = useId();
  const msgId = `${id}-msg`;
  const hasMsg = Boolean(error || hint);

  return (
    <div className={`${s.field} ${error ? s.fieldBad : ""}`}>
      <label htmlFor={id} className={s.label}>
        {label}
      </label>
      <div className={s.control}>
        <Icon icon={icon} width={20} className={s.controlIcon} />
        <input
          id={id}
          className={s.input}
          aria-invalid={Boolean(error)}
          aria-describedby={hasMsg ? msgId : undefined}
          {...inputProps}
        />
        {trailing}
      </div>
      {hasMsg && (
        <div id={msgId} className={error ? s.msgBad : s.msg}>
          {error || hint}
        </div>
      )}
    </div>
  );
}

/** Password input with its own show/hide button. */
export function PasswordField(props) {
  const [show, setShow] = useState(false);

  return (
    <AuthField
      {...props}
      type={show ? "text" : "password"}
      trailing={
        <button
          type="button"
          className={s.eye}
          onClick={() => setShow((v) => !v)}
          aria-label={show ? "ซ่อนรหัสผ่าน" : "แสดงรหัสผ่าน"}
          aria-pressed={show}
        >
          <Icon icon={show ? "solar:eye-closed-linear" : "solar:eye-linear"} width={20} />
        </button>
      }
    />
  );
}

export function FormAlert({ children }) {
  if (!children) return null;
  return (
    <div className={s.alert} role="alert">
      <Icon icon="solar:danger-triangle-bold" width={18} />
      <span>{children}</span>
    </div>
  );
}

export function SubmitLabel({ loading, loadingText, children }) {
  if (!loading) return children;
  return (
    <>
      <i className={s.spinner} aria-hidden="true" />
      <span>{loadingText}</span>
    </>
  );
}
